import styled from "styled-components"
import theme from "styles/theme-main"
import { fontSize, mobileFontSize, media } from "utils/utils"

export const Header = styled.h1`
  ${props => fontSize(props.fontsize)}
  font-weight: ${props => (props.variant === "account" ? "300" : "700")};
  padding: ${props =>
    props.variant === "default" || props.variant === "accountTitle"
      ? "0 0 24px 0"
      : "0 0 32px 0"};
  margin: ${props =>
    props.variant === "default" || props.variant === "accountTitle"
      ? "0 0 38px 0"
      : 0};
  letter-spacing: 6px;
  text-transform: uppercase;
  border-bottom: ${props =>
    props.variant === "default" || props.variant === "accountTitle"
      ? "1px solid" + theme.colors.border
      : null};

  ${media.md`
    ${props => mobileFontSize(props.variant, "md")};
    letter-spacing: 3px;
    margin: ${props =>
      props.variant === "default"
        ? "0 0 32px 0"
        : props.variant === "accountTitle"
        ? "0 0 21px 0"
        : 0};
    padding: ${props =>
      props.variant === "default"
        ? "0 12px 9px 8px"
        : props.variant === "accountTitle"
        ? "0 0 9px 0"
        : "0 0 17px 0"};
  
  `};
`
